<template>
  <b-container class="col-12 p-2 custPdfContainer">
      <b-col class="mt-2">
        <section class="pdf-item">
          <b-row>
            <b-col class="col-12">
              <b-img
                      :src=logoUrl alt="logo" class="imgLogo"></b-img>
              <h2 class="mt-4">Medicare Application</h2>
            </b-col>
            <b-col class="col-11 ml-3 p-0"><hr></b-col>
          </b-row>
          <b-row>
            <b-col class="col-12" v-if="form.PayerName">
              <label class="customLabel">Payer:</label> {{form.PayerName}}
            </b-col>
            <b-col class="col-12" v-if="form.PlanName">
              <label class="customLabel">Plan:</label> {{form.PlanName}}
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12" v-if="form.MemberFname">
              <label class="customLabel">Name:</label> {{form.title}} {{form.MemberFname}} {{form.MemberMname ? form.MemberMname+' '+form.MemberLname : form.MemberLname}}
            </b-col>
            <b-col class="col-12" v-if="form.homephone">
              <label class="customLabel">Home Phone Number:</label> {{form.homephone}}
            </b-col>
            <b-col class="col-12" v-if="form.altphone">
              <label class="customLabel">Alternate  Phone Number:</label> {{form.altphone}}
            </b-col>
            <b-col class="col-12" v-if="form.memberEmail">
              <label class="customLabel">Email:</label> {{form.memberEmail}}
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-6 p-0">
              <h6 class="ml-3 mt-2">Permanent Residence Address</h6>
              <b-col class="col-12" v-if="form.memberPerAddr">
                <label class="customLabel">Street 1:</label> {{form.memberPerAddr}}
              </b-col>
              <b-col class="col-12" v-if="form.memberPerAddr2">
                <label class="customLabel">Street 2:</label> {{form.memberPerAddr2}}
              </b-col>
              <b-col class="col-12" v-if="form.memberPerZip">
                <label class="customLabel">Zip:</label> {{form.memberPerZip}}
              </b-col>
              <b-col class="col-12" v-if="form.memberPerCity">
                <label class="customLabel">City:</label> {{form.memberPerCity}}
              </b-col>
              <b-col class="col-12" v-if="form.memberPerStateName">
                <label class="customLabel">State:</label> {{form.memberPerStateName}}
              </b-col>
              <b-col class="col-12" v-if="form.ResidentialCounty">
                <label class="customLabel">County:</label> {{form.ResidentialCounty}}
              </b-col>
            </b-col>
            <b-col class="col-6 p-0" v-if="form.memberMailAddr || form.memberMailStreet || form.memberMailZip || form.memberMailCity || form.memberMailStateName || form.MailingCounty">
              <h6 class="ml-3 mt-2">Mailing Address</h6>
              <b-col class="col-12" v-if="form.memberMailAddr">
                <label class="customLabel">Street 1:</label> {{form.memberMailAddr}}
              </b-col>
              <b-col class="col-12" v-if="form.memberMailStreet">
                <label class="customLabel">Street 2:</label> {{form.memberMailStreet}}
              </b-col>
              <b-col class="col-12" v-if="form.memberMailZip">
                <label class="customLabel">Zip:</label> {{form.memberMailZip}}
              </b-col>
              <b-col class="col-12" v-if="form.memberMailCity">
                <label class="customLabel">City:</label> {{form.memberMailCity}}
              </b-col>
              <b-col class="col-12" v-if="form.memberMailStateName">
                <label class="customLabel">State:</label> {{form.memberMailStateName}}
              </b-col>
              <b-col class="col-12" v-if="form.MailingCounty">
                <label class="customLabel">County:</label> {{form.MailingCounty}}
              </b-col>
            </b-col>
            <b-col class="col-11 ml-3 border-bottom p-0"></b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 p-0">
              <h6 class="ml-3 mt-2">Coverage Information</h6>
              <b-col class="col-12" v-if="form.medicardfullname">
                <label class="customLabel">Name:</label> {{form.medicardfullname}}
              </b-col>
              <b-col class="col-12" v-if="form.mediBeniIendtifier">
                <label class="customLabel">Medicare Number:</label> {{form.mediBeniIendtifier}}
              </b-col>
              <b-col class="col-11 ml-3 border-bottom p-0"></b-col>
            </b-col>
            <b-col class="col-12 p-0" v-if="form.paymentinterval">
              <h6 class="ml-3 mt-2">Payment Option</h6>
              <b-col class="col-12">
                <label class="customLabel">Premium payment option: </label>
                <span v-if="form.paymentinterval=='Q'"> Get a bill quarterly</span>
                <span v-if="form.paymentinterval=='R'"> Automatic deduction from your monthly Social Security or Railroad Retirement Board (RRB) benefit check</span>
              </b-col>
              <b-col class="col-11 ml-3 border-bottom p-0"></b-col>
            </b-col>
            <b-col class="col-12 p-0" v-if="form.otherhealthplan=='Y'">
              <h6 class="ml-3 mt-2">Other prescription drug coverage</h6>
              <b-col class="col-12" v-if="form.othercoveragename">
                <label class="customLabel">Name of other coverage:</label> {{form.othercoveragename}}
              </b-col>
              <b-col class="col-12" v-if="form.othercoverageid">
                <label class="customLabel">Member number:</label> {{form.othercoverageid}}
              </b-col>
              <b-col class="col-12" v-if="form.othercoveragegroup">
                <label class="customLabel">Group number:</label> {{form.othercoveragegroup}}
              </b-col>
              <b-col class="col-11 ml-3 border-bottom p-0"></b-col>
            </b-col>
            <b-col class="col-12 p-0" v-if="form.statemedicaid=='Y'">
              <h6 class="ml-3 mt-2">State Medicaid program</h6>
              <b-col class="col-12" v-if="form.medicaidnumber">
                <label class="customLabel">Medicaid Number:</label> {{form.medicaidnumber}}
              </b-col>
              <b-col class="col-11 ml-3 border-bottom p-0"></b-col>
            </b-col>
            <b-col class="col-12 p-0">
              <b-col class="col-12" v-if="form.infoPreference">
                <label class="customLabel">Language other than English:</label>
                <span v-if="form.infoPreference=='SPN'"> Spanish</span>
                <span v-if="form.infoPreference=='VIT'"> Vietnamese</span>
              </b-col>
              <b-col class="col-12" v-if="form.infoPreferenceFormat">
                <label class="customLabel">Information in an accessible format:</label>
                <span v-if="form.infoPreferenceFormat=='BRAILLE'"> Braille</span>
                <span v-if="form.infoPreferenceFormat=='LP'"> Large Print</span>
              </b-col>
              <b-col class="col-12" v-if="form.EmploymentStatus">
                <label class="customLabel">Employment Status:</label>
                <span v-if="form.EmploymentStatus=='Y'"> Yes</span>
                <span v-if="form.EmploymentStatus=='N'"> No</span>
              </b-col>
              <b-col class="col-12" v-if="form.SpouseEmploymentStatus">
                <label class="customLabel">Spouse Employment Status:</label>
                <span v-if="form.SpouseEmploymentStatus=='Y'">Yes</span>
                <span v-if="form.SpouseEmploymentStatus=='N'">No</span>
              </b-col>
            </b-col>
          </b-row>
          <b-row v-if="form.otherhealthplan!='Y' || form.statemedicaid!='Y'">
            <b-col class="col-12 p-0">
              <b-col class="col-12 p-0">
                <h6 class="ml-3 mt-2">Primary Care Physician (PCP)</h6>
              </b-col>
              <b-col class="col-12" v-if="form.PCPFirstName && form.PCPLastName">
                <label class="customLabel">PCP:</label>&nbsp;{{form.PCPFirstName}} {{form.PCPMiddleName ? form.PCPMiddleName+' '+form.PCPMiddleName : form.PCPLastName}}
              </b-col>
              <b-col class="col-12" v-if="form.IPAName">
                <label class="customLabel">Medical Group/IPA:</label> {{form.IPAName}}
              </b-col>
              <b-col class="col-12" v-if="form.PCPID">
                <label class="customLabel">PCP ID:</label> {{form.PCPID}}
              </b-col>
              <b-col class="col-12" v-if="form.PCPExistingMember">
                <label class="customLabel">Existing patient:</label>
                <span v-if="form.PCPExistingMember=='Y'">Yes</span>
                <span v-if="form.PCPExistingMember=='N'">No</span>
              </b-col>
            </b-col>
          </b-row>
         </section>
        <div class="html2pdf__page-break"/>
        <section class="pdf-item">
          <b-row  v-if="form.otherhealthplan=='Y' && form.statemedicaid=='Y'">
            <b-col class="col-12 p-0 mt-3">
              <b-col class="col-12 p-0">
                <h6 class="ml-3 mt-2">Primary Care Physician (PCP)</h6>
              </b-col>
              <b-col class="col-12" v-if="form.PCPFirstName && form.PCPLastName">
                <label class="customLabel">PCP:</label>&nbsp;{{form.PCPFirstName}} {{form.PCPMiddleName ? form.PCPMiddleName+' '+form.PCPMiddleName : form.PCPLastName}}
              </b-col>
              <b-col class="col-12" v-if="form.IPAName">
                <label class="customLabel">Medical Group/IPA:</label> {{form.IPAName}}
              </b-col>
              <b-col class="col-12" v-if="form.PCPID">
                <label class="customLabel">PCP ID:</label> {{form.PCPID}}
              </b-col>
              <b-col class="col-12" v-if="form.PCPExistingMember">
                <label class="customLabel">Existing patient:</label>
                <span v-if="form.PCPExistingMember=='Y'">Yes</span>
                <span v-if="form.PCPExistingMember=='N'">No</span>
              </b-col>
            </b-col>
            <b-col class="col-11 ml-3 border-bottom p-0"></b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 p-0" :class="(form.otherhealthplan=='Y' && form.statemedicaid=='Y') ? 'col-12 p-0' : 'col-12 p-0  mt-2'">
              <h6 class="ml-3 mt-2">Attestation Eligibility Form</h6>
              <b-col class="col-12">
              <span class="clearfix attFrm"
                    id="checkbox-1"
                    v-if="form.AttestationEligibility.newtomedicare"
              ><b-icon-check2 class="text-success"></b-icon-check2> I am new to Medicare</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.maoep"
                ><b-icon-check2 class="text-success"></b-icon-check2> I am enrolled in a Medicare Advantage plan and want to make a change during the Medicare Advantage Open Enrollment Peroid (MA OEP)</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.movedoutsideservicearea"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently moved outside of the service area for my current plan or I recently moved and this plan is a new option for me. I moved on {{form.AttestationEligibility.movedoutsideserviceareaDate ? new Date(form.AttestationEligibility.movedoutsideserviceareaDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.relfromincarceration"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently was released from incarceration. I was released on {{form.AttestationEligibility.relfromincarcerationDate ? new Date(form.AttestationEligibility.relfromincarcerationDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.returnedToUS"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently returned to the United States after living permanently outside of the U.S. I returned to the U.S. on {{form.AttestationEligibility.returnedToUSDate ? new Date(form.AttestationEligibility.returnedToUSDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.lawStatusUS"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently obtained lawful presence status in the United States. I got this status on {{form.AttestationEligibility.lawStatusUSDate ? new Date(form.AttestationEligibility.lawStatusUSDate).toLocaleDateString('en-US') : ''}}</span>

                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.medicaidChange"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently had a change in my Medicaid (newly got Medicaid, had a change in level of Medicaid assistance, or lost Medicaid) on {{form.AttestationEligibility.medicaidChangeDate ? new Date(form.AttestationEligibility.medicaidChangeDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.extrahelppayingmedicare"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently had a change in my Extra Help paying for Medicare prescription drug coverage (newly got Extra Help, had a change in the level of Extra Help, or lost Extra Help) on {{form.AttestationEligibility.extrahelppayingmedicareDate ? new Date(form.AttestationEligibility.extrahelppayingmedicareDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.bothMedicarenMedicaid"
                ><b-icon-check2 class="text-success"></b-icon-check2> I have both Medicare and Medicaid (or my state helps pay for my Medicare premiums) or I get Extra Help paying for my Medicare prescription drug coverage, but I haven’t had a change.</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.moveinoutLTCareFacility"
                ><b-icon-check2 class="text-success"></b-icon-check2> I am moving into, live in, or recently moved out of a Long-Term Care Facility (for example, a nursing home or long term care facility). I moved/will move into/out of the facility on {{form.AttestationEligibility.moveinoutLTCareFacilityDate ? new Date(form.AttestationEligibility.moveinoutLTCareFacilityDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.paceProgramLeft"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently left a PACE program on {{form.AttestationEligibility.paceProgramLeftDate}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.lostDrugCoverage"
                ><b-icon-check2 class="text-success"></b-icon-check2> I recently involuntarily lost my creditable prescription drug coverage (coverage as good as Medicare's). I lost my drug coverage on {{form.AttestationEligibility.lostDrugCoverageDate ? new Date(form.AttestationEligibility.lostDrugCoverageDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.leavingEmpUnionCoverage"
                ><b-icon-check2 class="text-success"></b-icon-check2> I am leaving employer or union coverage on {{form.AttestationEligibility.leavingEmpUnionCOverageDate ? new Date(form.AttestationEligibility.leavingEmpUnionCOverageDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.pharmacyAssProg"
                ><b-icon-check2 class="text-success"></b-icon-check2> I belong to a pharmacy assistance program provided by my state.</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.medicareContractEnding"
                ><b-icon-check2 class="text-success"></b-icon-check2> My plan is ending its contract with Medicare, or Medicare is ending its contract with my plan.</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.enrolledInMedicarePlan"
                ><b-icon-check2 class="text-success"></b-icon-check2> I was enrolled in a plan by Medicare (or my state) and I want to choose a different plan. My enrollment in that plan started on {{form.AttestationEligibility.enrolledInMedicarePlanDate ? new Date(form.AttestationEligibility.enrolledInMedicarePlanDate).toLocaleDateString('en-US') : ''}}</span>

                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.disenrolledSNP"
                ><b-icon-check2 class="text-success"></b-icon-check2> I was enrolled in a Special Needs Plan (SNP) but I have lost the special needs qualification to be in that plan. I was disenrolled from the SNP on {{form.AttestationEligibility.disenrolledSNPDate ? new Date(form.AttestationEligibility.disenrolledSNPDate).toLocaleDateString('en-US') : ''}}</span>
                <span class="clearfix attFrm"
                      v-if="form.AttestationEligibility.weatherEmergency"
                ><b-icon-check2 class="text-success"></b-icon-check2> I was affected by a weather-related emergency or major disaster (as declared by the Federal Emergency Management Agency -FEMA). One of the other states here applied to me, but I was unable to make my enrollment because of the natural disaster {{form.AttestationEligibility.weatherEmergencyDate ? new Date(form.AttestationEligibility.weatherEmergencyDate).toLocaleDateString('en-US') : ''}}</span>

              </b-col>
              <b-col class="col-11 ml-3 p-0 border-bottom"></b-col>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-6 p-0">
              <h6 class="ml-3 mt-2">
                <span v-if="form.acknowledgeAttest=='attest'">Representative</span>
                <span v-if="form.acknowledgeAttest=='acknowledge'">Signature</span>
              </h6>
              <b-col class="col-12" v-if="form.attstFirstName">
                <label class="customLabel">Name:</label> {{form.attstFirstName}} {{form.attstLastName}}
              </b-col>
              <b-col class="col-12" v-if="form.attstAddr && form.acknowledgeAttest=='attest'">
                <label class="customLabel">Address :</label> {{form.attstAddr}}
              </b-col>
              <b-col class="col-12" v-if="form.attstPhNum  && form.acknowledgeAttest=='attest'">
                <label class="customLabel">Phone Number:</label> {{form.attstPhNum}}
              </b-col>
              <b-col class="col-12" v-if="form.attstEnrollRel  && form.acknowledgeAttest=='attest'">
                <label class="customLabel">Relationship to Enrollee:</label>
                <span v-for="each in relncodes" :key="each.value">
                  {{each.value==form.attstEnrollRel ? each.text : ''}}
                </span>
              </b-col>
              <b-col class="col-12" v-if="form.ApplicationDate">
                <label class="customLabel">Date:</label>
                {{new Date(form.ApplicationDate).toLocaleDateString('en-US')}}
              </b-col>
            </b-col>
            <b-col class="col-6 p-0" v-if="form.emerContact">
              <h6 class="ml-3 mt-2">Emergency Contact</h6>
              <b-col class="col-12" v-if="form.emerContact">
                <label class="customLabel">Contact:</label> {{form.emerContact}}
              </b-col>
              <b-col class="col-12" v-if="form.emerContactRelationship">
                <label class="customLabel">Relationship:</label>
                <span v-for="item in relncodes" :key="item.value">
                  {{item.value==form.emerContactRelationship ? item.text : ''}}
                </span>
              </b-col>
              <b-col class="col-12" v-if="form.emerContactPhone">
                <label class="customLabel">Phone Number:</label> {{form.emerContactPhone}}
              </b-col>
              <b-col class="col-12" v-if="form.emerContactEmail">
                <label class="customLabel">Email Address:</label> {{form.emerContactEmail}}
              </b-col>
            </b-col>
          </b-row>
        </section>
      </b-col>
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";
import {BIconCheck2} from 'bootstrap-vue'
export default {
  name: "PrintPdfComponent",
  components: {BIconCheck2},
  data() {
    return {
      logoUrl: ''
    };
  },
  props: {
    form: Object,
    relncodes: Array
  },
  created() {
    if(process.env.VUE_APP_CLIENT){
      this.logoUrl = window.location.origin+'/images/logos/'+process.env.VUE_APP_CLIENT+'.png';
    }else{
      this.logoUrl = window.location.origin+'/images/logos/logo.png';
    }
  }

};
</script>
<style scoped>
  .customLabel{
    font-weight:500;
  }
  .custPdfContainer{
    font-size:16px;
  }
  .imgLogo {
    float: left;
    height: 100px;
    margin-right:10px;
  }
</style>
